export const languageElements = {
  items: {
    title1: {
      hu: 'Yusen Logistics (Hungary) Kft.',
      de: 'Yusen Logistics (Hungary) Kft.',
      en: 'Yusen Logistics (Hungary) Kft.',
    },

    title2: {
      hu: 'Branch Office Austria',
      de: 'Branch Office Austria',
      en: 'Branch Office Austria',
    },

    info1: {
      hu: 'Speditionsgeb.Obj. 263/3',
      de: 'Speditionsgeb.Obj. 263/3',
      en: 'Speditionsgeb.Obj. 263/3',
    },

    info2: {
      hu: '1300 Wien-Flughafen',
      de: '1300 Wien-Flughafen',
      en: '1300 Wien-Flughafen',
    },

    info3: {
      hu: 'Austria',
      de: 'Austria',
      en: 'Austria',
    },

    info4: {
      hu: '',
      de: '',
      en: '',
    },

    info5: {
      hu: 'Tel: +43 1 7007 32830',
      de: 'Tel: +43 1 7007 32830',
      en: 'Tel: +43 1 7007 32830',
    },

    info6: {
      hu: 'E-mail: ',
      de: 'E-mail: ',
      en: 'E-mail: ',
    },

    email: {
      hu: 'austria@at.yusen-logistics.com',
      de: 'austria@at.yusen-logistics.com',
      en: 'austria@at.yusen-logistics.com',
    },
  },
};
